import React from 'react';
import { MemberSpotlightContentModel } from 'src/api/models/MemberSpotlight';
import MemberSpotlight from 'src/molecules/Standard/Shared/MemberSpotlight/MemberSpotlight';

export default function getDynamicMemberSpotlight(boxProps: MemberSpotlightContentModel): React.ReactNode {
  return <MemberSpotlight {...boxProps} />;
}
